export enum EnumFileUploaderError {
  Default = 1,
  Required = 2,
  FileExist = 3,
  fileSizeLarge = 4,
  FileTypeNotMatch = 5,
  NotallowMultiple = 6,
}
